import { HYDRATE } from 'next-redux-wrapper';

import { Category } from '../../types/category.types';
import { SEARCH_AUTOCOMPLETE_CATEGORY_TREE_SET } from '../action-types/category.action-types';

export type CategoryReducer = {
  searchAutocompleteCategoryTree: Category[];
};

const initialState: CategoryReducer = {
  searchAutocompleteCategoryTree: [],
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      return { ...state, ...action.payload.categoryData };
    }
    case SEARCH_AUTOCOMPLETE_CATEGORY_TREE_SET: {
      return {
        ...state,
        searchAutocompleteCategoryTree: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default categoryReducer;
